module.exports = __webpack_public_path__ + "img/jjfa002.269d1e05.png";